import React, { useEffect, useRef, useState } from "react";
import { Button, Dropdown, Form } from "react-bootstrap";
import { SearchFiltersFormType } from "../Constants/Interfaces";
import DatePicker from "react-datepicker";
import {
  amenitiesTypes,
  featuresTypes,
  occassionTypes,
  spaceTypes,
  vibesTypes,
} from "../Constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDollar } from "@fortawesome/free-solid-svg-icons";

interface DropdownAreaType {
  title: string;
  children: any;
  updateSearch: Function;
  clearFilter: Function;
}

const DropdownArea: React.FC<DropdownAreaType> = ({
  children,
  title,
  updateSearch,
  clearFilter,
}) => {
  const [show, toogleShow] = useState(false);

  const dropdownRef = useRef<HTMLDivElement>(null);

  // ✅ close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        toogleShow(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Dropdown
      ref={dropdownRef}
      className="d-block mx-2 w-100"
      autoClose="outside"
      show={show}
    >
      <Dropdown.Toggle
        id="dropdown-autoclose-outside"
        className="w-100"
        onClick={() => toogleShow(!show)}
      >
        {title}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {children}

        <div className="text-right p-3 pt-0 d-flex align-items-center justify-content-between">
          <span
            className="clear-search-text as-link p-1"
            onClick={() => clearFilter()}
          >
            Clear
          </span>

          <Button
            onClick={() => {
              updateSearch();
              toogleShow(false);
            }}
          >
            Done
          </Button>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

const personCapacity = [
  {
    label: "1 to 10",
    value: "1 to 10",
  },
  {
    label: "11 to 25",
    value: "11 to 25",
  },
  {
    label: "26 to 50",
    value: "26 to 50",
  },
  {
    label: "51 to 100",
    value: "51 to 100",
  },
  {
    label: "Over 100",
    value: "Over 100",
  },
];

const SearchFilters: React.FC<SearchFiltersFormType> = ({
  data,
  updateSearchData,
}) => {
  const customCapRef = useRef(null);
  const [customCapacity, setCustomCapacity] = useState("");

  const [searchData, setSearchData] = useState({
    priceFrom: "",
    priceTo: "",
    date: new Date(),
    startTime: "",
    endTime: "",
    durarion: "",
    spaceType: "",
    capacity: "",
    features: [],
    amenities: [],
    vibes: [],
    occations: [],
  });

  const onChange = (field: string, value: string) => {
    setSearchData({
      ...searchData,
      [field]: value,
    });
  };

  const updateSearch = () => {
    updateSearchData({
      ...searchData,
      customCapacity,
    });
  };

  useEffect(() => {
    setSearchData({
      ...searchData,
      ...data,
    });
  }, [data]);

  return (
    <div className="filters-form">
      <div className="filter-item">
        <DropdownArea
          title="Occasion"
          updateSearch={updateSearch}
          clearFilter={() => {
            setSearchData({
              ...searchData,
              occations: [],
            });
          }}
        >
          <div className="row p-3 pt-2">
            {occassionTypes.map((item, index) => {
              const occations: Array<string> =
                (searchData && searchData.occations) || [];
              const isIncluded = occations.includes(item);

              return (
                <div className="col-12" key={`space-type-${index}`}>
                  <Form.Group>
                    <Form.Check
                      name="occations-types"
                      id={`occations-type-${item}`}
                      type="checkbox"
                      label={item}
                      onChange={(e) => {
                        const isChecked = e.target.checked;

                        let occations: Array<string> =
                          searchData && searchData.occations
                            ? [...searchData.occations]
                            : [];

                        if (isChecked) {
                          if (!occations.includes(item)) {
                            occations.push(item);
                          }
                        } else {
                          occations = occations.filter(
                            (tItem) => tItem !== item
                          );
                        }

                        console.log("occations :", occations);

                        onChange("occations", occations);
                      }}
                      checked={isIncluded}
                    />
                  </Form.Group>
                </div>
              );
            })}
          </div>
        </DropdownArea>
      </div>

      <div className="filter-item date-time-wrapper">
        <DropdownArea
          title="Date And Time"
          updateSearch={updateSearch}
          clearFilter={() => {
            setSearchData({
              ...searchData,
              date: "",
              startTime: "",
              endTime: "",
            });
          }}
        >
          <div className="p-3">
            <div className="row">
              <div className="col-md-8 date-picker-wrapper">
                <DatePicker
                  selected={searchData.date}
                  onChange={(date) => onChange("date", date)}
                  minDate={new Date()}
                  inline
                />
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <input
                    type="time"
                    name="startTime"
                    value={searchData.startTime}
                    onChange={(e) => onChange("startTime", e.target.value)}
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <input
                    type="time"
                    name="endTime"
                    value={searchData.endTime}
                    onChange={(e) => onChange("endTime", e.target.value)}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>
        </DropdownArea>
      </div>

      <div className="filter-item">
        <DropdownArea
          title="Number Of People"
          updateSearch={updateSearch}
          clearFilter={() => {
            setSearchData({
              ...searchData,
              capacity: "",
            });

            setCustomCapacity("");
          }}
        >
          <div className="row p-3 pt-2 pb-0">
            {personCapacity.map((item, index) => (
              <div className="col-12" key={`space-type-${index}`}>
                <Form.Check
                  name="space-types"
                  id={`space-capacity-${index}`}
                  type="radio"
                  label={item.label}
                  value={item.value}
                  onChange={(e) => onChange("capacity", String(item.value))}
                  checked={searchData.capacity === String(item.value)}
                />
              </div>
            ))}

            <div className="col-12 d-flex align-items-center mt-1 mb-3">
              <Form.Check
                name="space-types"
                id="space-type-custom"
                type="radio"
                label=""
                value={"custom"}
                onChange={(e) => {
                  onChange("capacity", "Custom");

                  if (e.target.checked) {
                    customCapRef.current.focus();
                  }
                }}
                checked={searchData.capacity === "Custom"}
              />

              <input
                ref={customCapRef}
                type="number"
                className="form-control"
                placeholder="Custom"
                value={customCapacity}
                onFocus={() => onChange("capacity", "Custom")}
                onChange={(e) => setCustomCapacity(e.target.value)}
              />
            </div>
          </div>
        </DropdownArea>
      </div>

      <div className="filter-item">
        <DropdownArea
          title="Space Type"
          updateSearch={updateSearch}
          clearFilter={() => {
            setSearchData({
              ...searchData,
              spaceType: "",
            });
          }}
        >
          <div className="row p-3 pt-2">
            {spaceTypes.map((item, index) => (
              <div className="col-12" key={`space-type-${index}`}>
                <Form.Check
                  name="space-types"
                  id={`space-type-${index}`}
                  type="radio"
                  label={item}
                  value={item}
                  onChange={(e) => onChange("spaceType", item)}
                  checked={searchData.spaceType === item}
                />
              </div>
            ))}
          </div>
        </DropdownArea>
      </div>

      <div className="filter-item">
        <DropdownArea
          title="Vibe"
          updateSearch={updateSearch}
          clearFilter={() => {
            setSearchData({
              ...searchData,
              vibes: [],
            });
          }}
        >
          <div className="row p-3 pt-2">
            {vibesTypes.map((item, index) => {
              const vibes: Array<string> =
                (searchData && searchData.vibes) || [];
              const isIncluded = vibes.includes(item);

              return (
                <div className="col-12" key={`space-type-${index}`}>
                  <Form.Group>
                    <Form.Check
                      name="vibes-types"
                      id={`vibes-type-${item}`}
                      type="checkbox"
                      label={item}
                      onChange={(e) => {
                        const isChecked = e.target.checked;

                        let vibes: Array<string> =
                          searchData && searchData.vibes
                            ? [...searchData.vibes]
                            : [];

                        if (isChecked) {
                          if (!vibes.includes(item)) {
                            vibes.push(item);
                          }
                        } else {
                          vibes = vibes.filter((tItem) => tItem !== item);
                        }

                        onChange("vibes", vibes);
                      }}
                      checked={isIncluded}
                    />
                  </Form.Group>
                </div>
              );
            })}
          </div>
        </DropdownArea>
      </div>

      <div className="filter-item">
        <DropdownArea
          title="Features"
          updateSearch={updateSearch}
          clearFilter={() => {
            setSearchData({
              ...searchData,
              features: [],
            });
          }}
        >
          <div className="row p-3 pt-2">
            {featuresTypes.map((item, index) => {
              const features: Array<string> =
                (searchData && searchData.features) || [];
              const isIncluded = features.includes(item);

              return (
                <div className="col-12" key={`space-type-${index}`}>
                  <Form.Group>
                    <Form.Check
                      name="features-types"
                      id={`features-type-${item}`}
                      type="checkbox"
                      label={item}
                      onChange={(e) => {
                        const isChecked = e.target.checked;

                        let features: Array<string> =
                          searchData && searchData.features
                            ? [...searchData.features]
                            : [];

                        if (isChecked) {
                          if (!features.includes(item)) {
                            features.push(item);
                          }
                        } else {
                          features = features.filter((tItem) => tItem !== item);
                        }

                        console.log("features :", features);

                        onChange("features", features);
                      }}
                      checked={isIncluded}
                    />
                  </Form.Group>
                </div>
              );
            })}
          </div>
        </DropdownArea>
      </div>

      <div className="filter-item">
        <DropdownArea
          title="Amenities"
          updateSearch={updateSearch}
          clearFilter={() => {
            setSearchData({
              ...searchData,
              amenities: [],
            });
          }}
        >
          <div className="row p-3 pt-2 mb-1">
            {amenitiesTypes.map((item, index) => (
              <div className="col-12" key={`space-type-${index}`}>
                <Form.Check
                  name="amenity-types"
                  id={`amenity-type-${index}`}
                  type="checkbox"
                  label={item}
                  value={item}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    let amenities = searchData.amenities
                      ? [...searchData.amenities]
                      : [];

                    if (isChecked) {
                      if (!amenities.includes(item)) {
                        amenities.push(item);
                      }
                    } else {
                      amenities = amenities.filter((tItem) => tItem !== item);
                    }

                    console.log("newAmenities", amenities);
                    onChange("amenities", amenities);
                  }}
                  checked={searchData.amenities.includes(item)}
                />
              </div>
            ))}
          </div>
        </DropdownArea>
      </div>

      <div className="filter-item">
        <DropdownArea
          title="Price"
          updateSearch={updateSearch}
          clearFilter={() => {
            setSearchData({
              ...searchData,
              priceFrom: "",
              priceTo: "",
            });
          }}
        >
          <div className="row p-3 pt-2">
            <div className="col-12">
              <div className="form-group">
                <div className="with-icon">
                  <FontAwesomeIcon icon={faDollar} />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="From"
                    onChange={(e) => onChange("priceFrom", e.target.value)}
                    value={searchData.priceFrom}
                  />
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group mb-0">
                <div className="with-icon">
                  <FontAwesomeIcon icon={faDollar} />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="To"
                    onChange={(e) => onChange("priceTo", e.target.value)}
                    value={searchData.priceTo}
                  />
                </div>
              </div>
            </div>
          </div>
        </DropdownArea>
      </div>
    </div>
  );
};

export default SearchFilters;
